<template>
    <div class="student-task-list-page">
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">DAFTAR ANGGOTA</h6>
                </div>
                <div class="col-lg-6 text-lg-right">
                    <b-button variant="primary" size="sm" @click="downloadDataUser()"><i class="fa fa-download" aria-hidden="true"></i> Download User </b-button>
                    <b-button variant="warning" size="sm" @click="downloadExcel()"><i class="fa fa-download" aria-hidden="true"></i> Download Template</b-button>
                    <b-button variant="info" size="sm" @click="showImportFormModal()"><i class="fa fa-upload" aria-hidden="true"></i> Upload Data</b-button>
                </div>
            </div>
            <div class="text-center text-muted">
                <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <b-row>
                            <b-col lg="2" class="my-1" style="width:100px">
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="1" class="my-1">
                                <b-button :disabled="isDisabled" variant="danger" size="sm" @click="confirmMultipleDeleteUser()"><i class="fa fa-trash" aria-hidden="true"></i> Hapus</b-button>
                            </b-col>
                            <b-col lg="6" class="my-1">
                            </b-col>
                            <b-col lg="4" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Cari"
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button style="border-radius:0px !important;" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table
                            :items="memberList"
                            :fields="fields"
                            :busy="isBusy"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            responsive="sm"
                            show-empty
                            small
                            @filtered="onFiltered"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template v-slot:cell(selected)="row">
                                <b-form-group class="my-3" >
                                    <input type="checkbox" @click="setButtonDelete(row.item)" v-model="row.item.selected" />
                                </b-form-group>
                            </template>
                            <template #cell(image_path)="row">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" height="50px" :src="row.item.image_path">
                                    </a>
                                </div>
                            </template>
                            <template #cell(full_name)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.full_name}} ({{row.item.email}})</label>
                                    <div class="text-muted"> {{row.item.user_status}}</div>
                                </div>
                            </template>

                            <template #cell(actions)="row">
                                <div class="my-2" v-if="user.type!='murid'">
                                    <a href="javascript:void(0)"  
                                        v-b-tooltip.hover title="Hapus" class="icon-clicked p-1" @click="confirmDelete(row.item)">
                                        <i class="fa fa-trash" aria-hidden="true"></i></a>
                                </div>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-lg-end justify-content-center py-2">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </card>
        <b-modal
			ref="user-class-import-form-modal"
			class="user-class-import-form-modal"
			size="md"
            title="Import Data"
            @show="resetImportForm"
            @hidden="resetImportForm"
			hide-footer
			no-close-on-backdrop
		>
            <b-form data-vv-scope="user-class-import-form">
                <b-form-group
                    label="Data"
                    label-for="data"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-file
                        ref="file_path"
                        name="file_path"
                        data-vv-as="File data"
                        v-model="import_form.file_data"
                        :state="Boolean(import_form.file_data)"
                        type="file"
                        placeholder="Pilih file disini. . ."
                        drop-placeholder="Drop file here..."
                        v-validate="'required'"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('user-class-import-form.file_path') }">{{ errors.first('user-class-import-form.file_path') }}</span>
                </b-form-group>
            </b-form>
            <hr class="m-0">
            <div class="form-footer d-flex justify-content-end mt-3">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideImportFormModal">BATAL</b-button>
                <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveImportSoal">UPLOAD</b-button>
                <b-button v-if="isMoreInfo" variant="info" size="md" style="width: 25%;" @click.prevent="showInfoLanjutModal()">Info Lanjut</b-button>
            </div>
		</b-modal>
        <b-modal
			ref="info-lanjut-modal"
			class="info-lanjut-modal"
			size="lg"
            title="Info Lanjut"
            hide-footer
			no-close-on-backdrop
		>
            <table id="info-lanjut" class="table table-info"
                responsive="sm"
                show-empty
                small
            >
                <thead>
                    <tr >
                        <th class="t-column-header">No.</th>
                        <th class="t-column-header">Baris ke</th>
                        <th class="t-column-header">Catatan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in failDataList" :key="index">
                        <td class="t-column-body">{{index+1}}</td>
                        <td class="t-column-body">{{item.row}}</td>
                        <td class="t-column-body">{{item.note}}</td>
                    </tr>
                </tbody>
            </table>
            <hr class="m-0">
            <div class="form-footer d-flex justify-content-end mt-3">
                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideInfoLanjutModal">Tutup</b-button>
            </div>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import axios from '../../../axiosHelper';
    // import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                import_form: {
                    file_data: null
                },
                failDataList: [],
                ids : [],
                isDisabled: true,
                isBusy: false,
                showLoader: false,
                isMoreInfo: false,
                items: [
                    { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
                    { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
                    {
                        isActive: false,
                        age: 9,
                        name: { first: 'Mini', last: 'Navarro' },
                        _rowVariant: 'success'
                    },
                    { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
                    { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
                    { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
                    {
                        isActive: true,
                        age: 87,
                        name: { first: 'Larsen', last: 'Shaw' },
                        _cellVariants: { age: 'danger', isActive: 'warning' }
                    },
                    { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
                    { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
                    { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
                ],
                fields: [
                    { key: "selected", label: "", sortable: false },
                    { key: 'image_path', label: 'Foto', sortable: false, class: 'foto-field'},
                    { key: 'full_name', label: 'Nama', sortable: true, sortDirection: 'desc', class: 'text-center' },
                    { key: 'actions', label: 'Aksi', class: 'action-field' }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 50,
                pageOptions: [5, 10, 25, 50, 100, 200, 500, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                task_appraisal_form: {
                    id: null,
                    score: null,
                    note: null
                },
                nilai: null
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                memberList: 'getMemberList',
                token: 'getToken'
            })
        },
        methods: {
            setButtonDelete(data) {
                setTimeout(() => {
                    if(data.selected==true){
                        this.ids.push(data);
                    }else{
                        var index = this.ids.indexOf(data);
                        if (index !== -1) {
                            this.ids.splice(index, 1);
                        }
                    }
                    if(this.ids.length>0){
                       this.isDisabled=false; 
                    }else{
                        this.isDisabled=true;
                    }
                }, 300);
            },
            downloadExcel() {
                let token = this.token
                let route = axios.defaults.baseURL+'/v1/classes/download-template-blank?token='+token
                window.open(route);
            },
            downloadDataUser() {
                let token = this.token
                let classId = this.$route.params.classId
                let taId = this.$route.params.taId
                let route = axios.defaults.baseURL+'/v1/classes/download-user/'+classId+'/'+taId+'?token='+token
                window.open(route);
            },
            showInfoLanjutModal() {
                this.$refs['info-lanjut-modal'].show();
            },
            hideInfoLanjutModal() {
                this.$refs['info-lanjut-modal'].hide()
            },
            showImportFormModal() {
                this.isMoreInfo = false,
                this.$refs['user-class-import-form-modal'].show();
            },
            hideImportFormModal() {
                this.$refs['user-class-import-form-modal'].hide()
                this.resetImportForm()
                this.getMemberList();
            },
            resetImportForm() {
                this.import_form.file_data = null
                this.$validator.reset()
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async getMemberList() {
                this.isBusy = true
                let classId = this.$route.params.classId
                let taId = this.$route.params.taId
				await this.$store.dispatch('getMemberList', { classId,taId })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async confirmMultipleDeleteUser() {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteMultipleMember(this.ids)
                    }
                })
			},
            async deleteMultipleMember(id) {
				await this.$store.dispatch('deleteMultipleMember', { id })
					.then((res) => {
                        this.ids = [];
                        this.getMemberList()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
                        this.ids = [];
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            confirmDelete(item) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteMemberClass(item)
                    }
                })
            },
            async deleteMemberClass(id) {
				await this.$store.dispatch('deleteMemberClass', { id })
					.then((res) => {
                        this.getMemberList()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            async saveImportSoal() {
                let scope = 'user-class-import-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let formData = new FormData()
                        formData.append('file', this.import_form.file_data)
                        this.$store.dispatch('importUserClassData', formData)
                            .then((res) => {
                                this.showLoader = false
                                var message = 'Berhasil';
                                var alert = 'success';
                                this.isMoreInfo = false;
                                this.failDataList = [];
                                if(res.data.data[0].success==0){
                                    message = 'Gagal';
                                    alert = 'error';
                                    this.isMoreInfo = true;
                                    this.failDataList = res.data.data[0].failData
                                }
                                var notif = 'Berhasil diupload '+res.data.data[0].success+', gagal '+res.data.data[0].failed
                                this.$swal.fire(message, notif, alert)
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                this.isMoreInfo = false;
                                this.failDataList = [];
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                this.$swal.fire('Failed', error.data.message, 'error')
                                }
                            })
                    }
                })
            }
        },
        mounted() {
            this.totalRows = this.memberList.length
        },
        async created() {
            await this.getMemberList()
        }
    }
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
#info-lanjut {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#info-lanjut td, #info-lanjut th {
  border: 1px solid #ddd;
  padding: 8px;
}

#info-lanjut tr:nth-child(even){background-color: #f2f2f2;}

#info-lanjut tr:hover {background-color: #ddd;}

#info-lanjut th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
</style>